import {
  BABBEL_APP_VERSION,
  ROLLBAR_ACCESS_TOKEN,
  ROLLBAR_API_URL,
  ROLLBAR_ENVIRONMENT,
} from 'src/dataLayer/env'
import { getTrackingUUID } from 'src/dataLayer/localData/cookies'

const pickStatus = ({ status }) => ({ status })

const declareReporter = (level) => (body, rawPayload) => {
  if (rawPayload?.body && rawPayload.body.token && rawPayload.body.token.password) {
    // eslint-disable-next-line no-param-reassign -- Legacy
    delete rawPayload.body.token.password
    // eslint-disable-next-line no-param-reassign -- Legacy
    delete rawPayload.body.token.email
  }
  const payload = { ...rawPayload, trackingUuid: getTrackingUUID() }

  try {
    return globalThis
      .fetch(ROLLBAR_API_URL, {
        body: JSON.stringify({
          access_token: ROLLBAR_ACCESS_TOKEN,
          data: {
            body: {
              message: {
                body,
                payload,
              },
            },
            client: {
              javascript: {
                browser: navigator.userAgent,
              },
            },
            // TODO: remove BABBEL_APP_VERSION, it is not available in CI
            code_version: BABBEL_APP_VERSION,
            environment: ROLLBAR_ENVIRONMENT,
            level,
            // TODO: We need to change the platform value here
            // when we handle WebView. value should depend on
            // route, if /login-mobile/ then "mobile", else "browser"
            platform: 'browser',
            request: {
              query_string: globalThis.location.search,
              url: globalThis.location.href,
            },
          },
        }),
        method: 'POST',
      })
      .then(pickStatus, pickStatus)
  } catch {
    return Promise.resolve({ status: undefined })
  }
}

const reportError = declareReporter('error')
const reportWarning = declareReporter('warning')

export { reportError, reportWarning }
